import { __extends as m } from "./index11.js";
import { RemoteMetrics as c } from "./index57.js";
import { CoreStats as l } from "./index58.js";
var i, a = (
  /** @class */
  function(t) {
    m(n, t);
    function n() {
      return t !== null && t.apply(this, arguments) || this;
    }
    return n.initRemoteMetrics = function(o) {
      i = new c(o);
    }, n.prototype.increment = function(o, r, e) {
      t.prototype.increment.call(this, o, r, e), i?.increment(o, e ?? []);
    }, n;
  }(l)
);
export {
  a as Stats
};
//# sourceMappingURL=index42.js.map
